"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'access.status.active': '活跃',
    'access.status.inactive': '非活跃',
};
